export type CommentTimeNowProvider = () => Date;

const plural = (value: number, unit: string) =>
  `${value} ${unit}${value === 1 ? "" : "s"} ago`;

export const formatCommentTime = (
  isoDate: string,
  nowProvider: CommentTimeNowProvider = () => new Date(),
) => {
  const now = nowProvider();
  const date = new Date(isoDate);
  const diffMs = now.getTime() - date.getTime();

  if (!Number.isFinite(diffMs)) return "";

  if (diffMs < 0) return "Just now";

  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 1) return "Just now";
  if (diffMinutes < 60) return plural(diffMinutes, "min");
  if (diffHours < 24) return plural(diffHours, "hr");
  if (diffDays < 7) return plural(diffDays, "day");
  if (diffDays < 30) return plural(Math.floor(diffDays / 7), "week");

  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
